<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">
        <span>{{ title }}</span>
    </h4>
</div>

<div class="modal-body">
    <app-job-match-profile-on-conference *ngIf="actionType == 'candidateBooklet'" style="margin-top:40px"
        [workflowStep]="workflowStep"
        [jobMatchId]="jobMatchId"
        [jobId]="jobId"
        [candidateId]="candidateId"
        [scheduleId]="scheduleId"
        [displaySchedules]="false"
        [displayFeedback]="true"
        [displayCommunication]="true"
        [feedbackUserIdsList]="feedbackUserIdsList"
        context="conference">
    </app-job-match-profile-on-conference>
    <div class="row" *ngIf="actionType == 'feedbackEditApproval'">
        <div class="col-xs-12 px-4 pb-4">
            <b>{{editFeedbackApprovalInfo.requesterName}}</b> requests permission to edit the feedback.
        </div>
        <div class="col-xs-12 px-4 pb-4 d-flex justify-content-end">
            <div class="d-flex" style="gap: 10px;">
                <button class="btn btn-primary" (click)="saveAndApproveFeedbackEdit()">
                    Save & Approve
                </button>
                <button class="btn btn-primary" (click)="approveFeedbackEdit()">
                    Approve
                </button>
                <button class="btn btn-danger" (click)="denyRequestToEditFeedback()">
                    Deny
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="actionType == 'jobProfile'">
        <app-job-profile [jobId]="jobId" [ngStyle]="{'display': isJobProfileLoaded ? '' : 'none'}"></app-job-profile>
        <div *ngIf="!isJobProfileLoaded" class="animate-if candidate-card-loader-div text-center" style="height: 600px;">
            <div class="skeleton-paragraph skeleton-loading" style="width: 60%; margin: 0 auto 10px;"></div><div class="skeleton-paragraph skeleton-loading" style="width: 40%; margin: 0 auto;"></div>
        </div>
    </div>
</div>
